<template>
  <label style="font-size:110%">{{ $t(label) }}</label>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: 'common.emptyString'
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped></style>
